// ----------------------------------------------------------------------
const account = {
  displayName: 'Hifix Interio',
  email: 'hifix@gmail.com',
  photoURL: '/assets/images/avatars/hifixlogo.jpg',
};

export default account;
